// Response data's from server
let tangent_facemap_data;

let tangent_selfie_id;

// Product ID to single Variant ID mapping
let tangent_selected_product_map;

const default_addToCartText = "Add to cart";
const default_addedToCartText = "Added to Cart!";
const out_of_stock_text = "Out of Stock";
const no_products_found_text = "No products found. Please retry!";

let cartDiscount = 50;
let tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map = {};

// Tab title mapping based on tags
const tabs_title_mapping = {
  section_basic: "Basic",
  section_essentials: "Essential",
  section_works: "Works"
}
// Message for each conditions
const condition_text_mapping = {
  dark_circles: "Prone to dark circles here? Try our <a href='/products/reviving-eye-brightener' target='_blank'><u>Reviving Eye Brightener</u></a>",
  wrinkles: "Prone to wrinkles here? Try our <a href='/products/complete-serum' target='_blank'><u>Complete Serum</u></a>",
  rosacea: "Prone to rosacea here? Try our <a href='/products/calming-mask' target='_blank'><u>Calming Mask</u></a>",
  texture: "Prone to texture here? Try our <a href='/products/resurfacing-accelerator' target='_blank'><u>Resurfacing Accelerator</u></a>",
  darkspots: "Prone to darkspots here? Try our <a href='/products/brightening-serum' target='_blank'><u>Brightening Serum</u></a>",
  acne: "Prone to acne here? Try our <a href='/products/clarifying-liquid-peel' target='_blank'><u>Clarifying Liquid Peel</u></a>"
}

// Add default image url here
const tangent_default_selfie_image_url = "https://file.tangent.ai/quiz-content/merchants/glo24k/image/7427568944529883-default-selfie-image.jpg";
const default_variant_image_url = "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper");
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message");


window.onload = function () {
  checkoutDataApiCall(getClientResponseId());
}

function getClientResponseId() {
  // Current Page Load URL
  const tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id) {
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + tangent_response_id + "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
      .then(data => {
        return data.json();
      })
      .then(response => {
        checkoutDataProcess(response);
        return response;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

function attachScrollToEvent() {
  document
    .querySelectorAll(".scroll-to-btn")
    .forEach(button => {
      button.addEventListener("click", () => {
        scrollToTarget(button.dataset.scrollto);
      });
    });
}

function scrollToTarget(targetId) {
    const target = document.getElementById(targetId);

    if (!target) return;

    const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        120;

    window.scrollTo({
        top,
        behavior: "smooth"
    });
}

async function checkoutDataProcess(response) {

    const recommendedProducts = response.products;
    const productSections = response.product_sections;
    const textSections = response.text_sections;

    await processSelfieData(response);

    appendSectionBelowSelfie(response.tags);

    setDefaultCurrency();

    setTangentSelfieSection(response);

    initializeSections(
        productSections,
        textSections
    );

    renderRecommendedProducts(
        recommendedProducts,
        productSections
    );

    finalizeCheckoutView(response);

    attachScrollToEvent();
}


async function processSelfieData(response) {
    if (!response.selfie_id) return;
    setSelfieId(response.selfie_id);
    await getSelfieMapping(response);
    showSkinHealthSection();
}


function showSkinHealthSection() {
    document.getElementById(
        "tangent_score_description"
    ).style.display = "block";

    document.getElementById(
        "skin-health-title-container"
    ).style.display = "block";
}


function setDefaultCurrency() {
    if (!tangent_client_domain_currency) {
        tangent_client_domain_currency = "$";
    }
}


function initializeSections(
  productSections,
  textSections
) {

    if (productSections) {
        createProductSection(
            productSections,
            textSections
        );

        initializeTabs();
    }

    if (textSections) {
        createTextSection(
            productSections,
            textSections
        );
    }
}

function initializeTabs() {

    document.querySelector("#tab-wrapper").style.display = "block";

    const tabContents = document.querySelectorAll(".tabcontent");
    const tabLinks = document.querySelectorAll(".tablinks");

    if (tabContents.length > 0) {
        tabContents[tabContents.length - 1].style.display = "block";
    }

    if (tabLinks.length > 0) {
        tabLinks[tabLinks.length - 1].classList.add("active");
    }
}


function finalizeCheckoutView(response) {
    document.getElementById(
        "tangent_custom_tabs"
    ).style.display = "flex";

    if (!response.description) {
        document.querySelector(
        "#tangent-general-text"
        ).style.display = "block";
    }
}

function renderRecommendedProducts(
  tangentRecommendedProducts,
  tangentProductSections
) {
    if (!tangentRecommendedProducts?.length) {
        document.querySelector("#tangent-general-text").innerHTML = no_products_found_text;
        return;
    }

    if (!tangentProductSections) return;

    tangent_selected_product_map = {};

    // Fast product lookup by id
    const productMap = createProductLookup(
        tangentRecommendedProducts
    );

    const sectionMarkup = {};

    Object.entries(tangentProductSections).forEach(
        ([sectionName, productIds]) => {

        if (sectionName === "section_treatment_recommendation") return;

        sectionMarkup[sectionName] = "";

        productIds.forEach((productId, index) => {

            const product = productMap[productId];

            if (!product) return;

            const selectedVariant = product.variants.edges[0].node;

            tangent_selected_product_map[product.id] = selectedVariant.id;

            const productPrice = selectedVariant.price;

            const discountedPrice = calculateDiscount(cartDiscount, productPrice);

            const variantImageUrl = product.images.nodes[0].url;

            const variantProductUrl = `${tangent_client_domain_url}/products/` + `${product.handle}?variant=${selectedVariant.id}`;

            let isAvailable = isProductAvailable(product, selectedVariant);

            let buttonText = default_addToCartText;
            let buttonClass = '';

            if(!isAvailable){
                buttonText = out_of_stock_text;
                buttonClass = 'disable-btn';
            }
            else{
                updateSectionAllToCartLink(
                    sectionName,
                    tangent_selected_product_map[product.id]
                );
            }

            sectionMarkup[sectionName] += createProductHTML(
                product,
                index,
                sectionName,
                selectedVariant,
                productPrice,
                discountedPrice,
                variantImageUrl,
                variantProductUrl,
                buttonText,
                buttonClass
            );
        });
        }
    );

    injectSectionProducts(sectionMarkup);

    updateProductMetaSection(
        tangentRecommendedProducts
    );

    enableButtonListener();
}

function isProductAvailable(product, variant) {
  if (!product || !variant) return false;

  const status = product.status?.toUpperCase();

  return (
    status === "ACTIVE" &&
    variant.availableForSale === true
  );
}


function createProductLookup(products) {
  return products.reduce((map, product) => {
    map[String(product.id)] = product;
    return map;
  }, {});
}

function createProductHTML(
  product,
  index,
  section,
  selected_variant,
  product_price,
  discountedPrice,
  variant_image_url,
  variant_product_url,
  buttonText,
  buttonClass
) {
    return `
        <div>
            <a
                id="url_tangent_product_${index}"
                class="tangent-text-link"
                target="_blank"
                href="${variant_product_url}"
            >
                <img
                id="image_tangent_product_${index}"
                src="${variant_image_url}"
                class="tangent_product_image"
                >

                <p class="tangent-product-title tangent_product_title_text">
                <b>${product.title}</b>
                </p>

                <p
                id="price_tangent_product_${index}"
                class="tangent_product_price_text"
                >
                <del>
                    ${tangent_client_domain_currency}${product_price}
                </del>

                <strong style="color:red">
                    ${tangent_client_domain_currency}${discountedPrice}
                </strong>
                </p>

                <p class="discount-coupon-text">
                Buy it now at <b>50%</b> off regular price
                using code <b>GLO50</b>
                </p>
            </a>

            <div id="${section}_variant_${index}"></div>

            <button
                type="button"
                class="tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${buttonClass}"
                id="${selected_variant.id}"
                data-section="${section}"
                data-index="${index}"
            >
                ${buttonText}
            </button>

        </div>
    `;
}


function injectSectionProducts(sectionMarkup) {
    for (const section in sectionMarkup) {
        let grid = document.getElementById(section + "_product_grid");

        if (grid) {
            grid.innerHTML = sectionMarkup[section];
        }
    }
}


function updateProductMetaSection(products) {
    if (products.length === 1) {
        addProductMetaData(products);
    } else {
        document.querySelector(".product-meta-section").style.display = "block";
        document.querySelector("#tangent-tab-heading").innerHTML =
        "Your Perfect Glo24K Products";
    }
}

const appendSectionBelowSelfie = (tags) => {
    const section_container = createElement('tangent_recommendation_info', 'div');
    appendElementNextTo('tangent_score_description', section_container);
}

const appendElementNextTo = (target_element_id, new_element) => {
    let target_element = document.getElementById(target_element_id);
    target_element.parentNode.insertBefore(new_element, target_element.nextSibling)
}

function disableCartButton(button) {
    button.textContent = out_of_stock_text;
    button.classList.add("disable-btn-wrapper");
}

function updateSectionAllToCartLink(
  section,
  variantId
) {
  const vid = variantId.split("/").pop();
    if (!sections_add_to_cart_map[section]) {
        sections_add_to_cart_map[section] = {
        count: 1,
        cart_link:
            `${tangent_client_domain_url}/cart/add?id[]=${vid}`,
        list: [vid]
        };

        return;
    }

    const sectionCart =
        sections_add_to_cart_map[section];

    sectionCart.count++;
    sectionCart.cart_link += `&id[]=${vid}`;
    sectionCart.list.push(vid);
    
    if (sectionCart.count > 1) {
        document.getElementById(
            `${section}_add_all_to_cart`
            )?.style.setProperty(
            "display",
            "block"
        );
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {
  if (sections_add_to_cart_map[section] != undefined) {
    // document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    addAlltoCart(sections_add_to_cart_map[section].list, `${section}_add_all_to_cart`)
  }
  else {
    var x = document.querySelector("#message-text");
    x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
    x.className = "show";
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

// //add all to cart
function addAlltoCart(productList, btnId) {
  const btn = document.getElementById(btnId);
  btn.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;
  const formData = {
    "items": productList.map((id) => {
      return {
        id,
        "quantity": 1,
        "properties": {
          "_type": "tangent_quiz"
        }
      }
    })
  }
  addToCartApi(formData, btn)
}

function addToCart(btn) {
  btn.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;
  const variantId = btn.id.split("/").pop();
  const section = btn.dataset.section || "";

  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
        properties: {
          _type: section
        }
      }
    ]
  };

  addToCartApi(formData, btn);
}

//add to cart api function
function addToCartApi(formData, btn) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (btn != undefined) {
        btn.innerHTML = default_addedToCartText;
        btn.classList.add("added-to-cart-style");
      }
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

//display product meta details
function addProductMetaData(tangent_recommended_products) {
  document.querySelector(".device-meta-section").style.display = "block";
  const recommendedDevice = tangent_recommended_products[0]
  const descriptionBlock = document.querySelector(".device-description-block");
  const directionBlock = document.querySelector(".device-direction-block");
  descriptionBlock.innerHTML = recommendedDevice.descriptionHtml;
  const directionElement = document.createElement("p");
  directionElement.classList.add("direction-block")
  directionElement.innerHTML = recommendedDevice.product_directions.value;
  directionBlock.appendChild(directionElement)
}


const createElement = (button_id, element_type) => {
  const element = document.createElement(element_type);
  element.id = button_id;
  return element;
}

// function to get the discounted price
function calculateDiscount(cartDiscount, product_price) {
  // Ensure inputs are numbers
  const discountPercent = Number(cartDiscount) || 0;
  const price = Number(product_price) || 0;

  // Calculate discount amount
  const discountAmount = (price * discountPercent) / 100;

  // Final price after discount
  const discountedPrice = price - discountAmount;

  // Round to 2 decimal points properly
  return discountedPrice.toFixed(2);
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext('2d');
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x: Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y: Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne", "darkspots", "wrinkles", "dark_circles", "rosacea"];
  var click_found = false;
  for (var sc = 0; sc < skin_conditions.length; sc++) {
    if (isPointInsidePoligon(point, tangent_facemap_data[skin_conditions[sc]])) {
      openConditionMessage(canvas, skin_conditions[sc]);
      click_found = true;
      break;
    }
  }
  if (!click_found) {
    tangent_condition_message_popoup.style.display = "none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas, condition) {
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x: event.clientX - rect.left,
    _y: event.clientY - rect.top
  }

  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display: "block",
      left: (point._x) + "px",
      top: (point._y) + "px"
    }
  );
}

// Custom function for scroll to operation
function scrollToElement(element_id) {
  let element;
  if (element_id == "daily_wellbeing") {
    element = document.getElementById('shopify-section-template--16909643743394__featured_text_wH7DN3');
  }
  if (element != undefined) {
    element.scrollIntoView();
  }
}

// Check whether click is inside condition points
function isPointInsidePoligon(pt, points_list) {
  // https://stackoverflow.com/a/29915728/960654
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

  var x = pt._x,
    y = pt._y

  var inside = false;
  for (var c = 0; c < points_list.length; c++) {
    var points = points_list[c];
    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
      var xi = points[i][0],
        yi = points[i][1]
      var xj = points[j][0],
        yj = points[j][1]

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
  }
  return inside
}

// Toggle - hide higlight button
function hideHightlightButtonDisplayToggle(display) {
  document.querySelector("#hideHighlight").style.display = display;
}

// Toggle - show highlight button
function showHighlightButtonDisplayToggle(display) {
  document.querySelector("#showHighlight").style.display = display;
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display) {
  document.querySelector("#selfie_canvas").style.display = display;
}

// Toggle hide highlight and show highlight
function toggleHighlight(status) {
  if (status) {
    hideHightlightButtonDisplayToggle("block");
    showHighlightButtonDisplayToggle("none");
    selfieCanvasDisplayToggle("block");
  }
  else {
    hideHightlightButtonDisplayToggle("none");
    showHighlightButtonDisplayToggle("block");
    selfieCanvasDisplayToggle("none");
  }
}

function createSectionContainer(sectionName) {
  const sectionContainer = document.createElement("div");

  sectionContainer.id = `${sectionName}_container`;
  sectionContainer.classList.add(
    "tabcontent",
    `${sectionName}_container`
  );

  return sectionContainer;
}

// Add to cart button for sections
function createSectionAddAllToCart(sectionName) {
  const button = document.createElement("button");

  button.id = `${sectionName}_add_all_to_cart`;
  button.type = "button";
  button.textContent = "Add all to Cart";

  button.className = `
    section_add_all_to_cart
    ${sectionName}_add_all_to_cart
  `.trim();

  button.addEventListener("click", () => {
    addAllTocartFunction(sectionName);
  });

  return button;
}

function addSectionProductGridContainer(sectionName) {
  const productGrid = document.createElement("div");

  productGrid.id = `${sectionName}_product_grid`;

  productGrid.classList.add(
    "section_product_grid",
    `${sectionName}_product_grid`
  );

  return productGrid;
}

function createTabButton(sectionName) {
  const tabButton = document.createElement("button");

  tabButton.id = `${sectionName}_tab_button`;
  tabButton.type = "button";
  tabButton.name = sectionName;
  tabButton.textContent = getTabTitle(sectionName);

  tabButton.classList.add("tablinks");

  tabButton.addEventListener("click", () => {
    switchTab(tabButton);
  });

  tangent_custom_tabs.appendChild(tabButton);

  return tabButton;
}

function getTabTitle(section) {
  return (
    tabs_title_mapping[section] ??
    section
      .replace("section_", "")
      .replace(/_/g, " ")
      .toUpperCase()
  );
}

// Product Section Creation
function createProductSection(product_sections, text_sections) {
  for (const section_name in product_sections) {
    // The created container will have both a container to show text and products
    var section_container = createSectionContainer(section_name);

    // Creating text sections before products sections if exists
    if (text_sections != undefined) {
      createTextSectionBeforeProducts(text_sections, section_container, section_name);
    }

    // Creating section to add all products
    section_container.appendChild(addSectionProductGridContainer(section_name));

    // Creating add all to cart button for the section    
    section_container.appendChild(createSectionAddAllToCart(section_name));

    // Add to main container wrapper
    tangent_sections_wrapper_element.appendChild(section_container);
    createTabButton(section_name);
  }
}

function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
  if (!textSections?.[sectionName]) return;

  const sectionDiv = document.createElement("div");
  sectionDiv.id = `${sectionName}_text_container`;
  sectionDiv.classList.add(
    "section_text_container",
    `${sectionName}_text_container`
  );
  sectionDiv.innerHTML = textSections[sectionName].join(" ");
  sectionContainer.appendChild(sectionDiv);
}
function createTextSection(productSections, textSections) {
  for (const sectionName in textSections) {

    // skip if already has product section
    if (productSections?.[sectionName]) continue;

    const sectionContainer = createSectionContainer(sectionName);

    createTextSectionBeforeProducts(
      textSections,
      sectionContainer,
      sectionName
    );

    appendTextOnlySection(sectionName, sectionContainer);
  }
}


function appendTextOnlySection(sectionName, sectionContainer) {

  if (sectionName === "section_selfie") {
    const parent = document.querySelector(
      "#section_selfie_container_parent"
    );

    sectionContainer.classList.remove("tabcontent");
    parent?.appendChild(sectionContainer);
    return;
  }

  if (sectionName === "section_additional_content") {
    const parent = document.querySelector(
      "#section_additional_content_container_parent"
    );

    sectionContainer.classList.remove("tabcontent");
    parent?.appendChild(sectionContainer);
    return;
  }

  tangent_sections_wrapper_element.appendChild(sectionContainer);
}

function setTangentSelfieSection(response) {

  if (response?.selfie_html) {
    hideHightlightButtonDisplayToggle("flex");
    return;
  }

  if (response?.selfie_url) {
    hideHightlightButtonDisplayToggle("flex");
    document.querySelector("#tangent_selfie_image").src =
      response.selfie_url;
    return;
  }

  if (tangent_default_selfie_image_url) {
    hideLoading();
    showSelfieImage();

    document.querySelector("#canvas_img").src =
      tangent_default_selfie_image_url;

    return;
  }

  document.querySelector("#tangent_selfie_container").style.display = "none";
}

function switchTab({ name }) {
  document
    .querySelectorAll(".tabcontent")
    .forEach(tab => tab.style.display = "none");

  document
    .querySelectorAll(".tablinks")
    .forEach(tab => tab.classList.remove("active"));

  document.getElementById(`${name}_container`)?.style.setProperty(
    "display",
    "flex"
  );

  document.getElementById(`${name}_tab_button`)
    ?.classList.add("active");
}

function enableButtonListener() {
  document
    .querySelectorAll(".tangent-product-add-btn-wrapper")
    .forEach(button => {
      button.addEventListener("click", () => {
        addToCart(button);
      });
    });
}

async function getSelfieMapping(response) {
  try {
    const selfieId = response.selfie_id;

    const apiUrl =
      `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfieId}&user=mango`;

    const res = await fetch(apiUrl);

    if (!res.ok) {
      console.error(`Request failed: ${res.status}`);
      return;
    }

    const responseJson = await res.json();

    handleSelfieMappingResponse(response, responseJson);

  } catch (error) {
    console.error("Selfie mapping error:", error);
  }
}


function handleSelfieMappingResponse(response, responseJson) {
  tangent_facemap_data =
    responseJson.selfie_record?.[0]?.facemap;

  if (!tangent_facemap_data) return;

  setScores(tangent_facemap_data.scores);

  checkUserHistory(
    response,
    tangent_facemap_data.scores
  );

  document.querySelector("#canvas_img").src =
    tangent_facemap_data.url;

  hideLoading();
  showSelfieImage();
}

function setElementDisplay(selector, display) {
  document.querySelector(selector)?.style.setProperty(
    "display",
    display
  );
}

function hideLoading() {
  setElementDisplay("#loading-section", "none");
}

function showSelfieImage() {
  setElementDisplay("#canvas_img", "block");
}

function findFirstMatchingQuiz(data, tags) {
  return data.find(item => tags.includes(item.tag)) || null;
}


//check for userhistory score to determine overall score
function checkUserHistory(response, scores) {
  if (response.user_history.length == 0) {
    displaySkinHealthScore(scores.overall)
  } else {
    var baseOverAllScore = scores.overall;
    var selfie_id = response?.user_history[0].selfie_id;
    var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id=" + selfie_id + "&user=mango";
    var xmlhttp = new XMLHttpRequest();


    xmlhttp.onreadystatechange = function () {
      var DONE = (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
      if (xmlhttp.readyState === DONE) {
        if (xmlhttp.status === 200) {
          var response_json = JSON.parse(xmlhttp.responseText);
          var facemap = response_json["selfie_record"][0].facemap;

          var currentOverAllScore = facemap.scores.overall;

          // Compare & adjust
          let newOverallScore = Math.max(baseOverAllScore, currentOverAllScore);
          if (baseOverAllScore == currentOverAllScore) {
            newOverallScore = baseOverAllScore + 1;
          }

          // Cap at 99
          if (newOverallScore > 99) {
            newOverallScore = 99;
          }
          displaySkinHealthScore(newOverallScore);
        } else {
          console.log("Error", xmlhttp.status);
        }
      }
    }
    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
  }
}

//calcualte average score of skin attributes' score 
function displaySkinHealthScore(score) {
  document.querySelector(".score_text_container").style.display = "flex";
  const progressValue = document.querySelector(".percentage");
  let startValue = 0,
    endValue = score,
    speed = 10;

  const progress = setInterval(() => {
    startValue++;
    progressValue.textContent = `${startValue}%`;

    if (startValue === endValue) {
      clearInterval(progress);
    }
  }, speed);
  // document.querySelector(".selfie_text_container_block").style.display = "block";
}

function setScores(scores) {

  const scoreMap = {
    acne: "Acne",
    rosacea: "Rosacea",
    darkspots: "DarkSpots",
    wrinkles: "Wrinkles",
    dark_circles: "DarkCircles",
    texture: "Texture"
  };

  let concernCount = 0;

  Object.entries(scores).forEach(([key, value]) => {
    const label = scoreMap[key];

    if (!label) return;

    document.querySelector(
      `#${label}_Score_container`
    )?.style.setProperty("display", "flex");

    document.querySelector(
      `#${label}_Score`
    ).textContent = value;

    concernCount++;
  });

  if (concernCount > 0) {
    document.querySelector(
      "#facemap_all_scores_container"
    )?.style.setProperty("display", "flex");
  }
}

function setSelfieId(id) {
  tangent_selfie_id = id;
}

function getSelfieId() {
  return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas() {
  if (getSelfieId() != null) {

    var selfie_canvas = document.querySelector('#selfie_canvas');
    var selfie_canvas_ctx = selfie_canvas.getContext('2d');

    // selfie_canvas.addEventListener('click', function(e) {
    //     getCursorPosition(selfie_canvas, e)
    // });

    var canvas_img = document.querySelector('#canvas_img');
    setCanvasDimensions(selfie_canvas, canvas_img);

    var prop = getImageSize(canvas_img.naturalWidth);

    drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
    drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
    drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
    drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
    drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
    drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"], getAcneLineWidth(prop));
  }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop = imgWidth / 400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if (prop < 1) {
    return 'blur(1px)';
  }
  else if (prop < 1.5) {
    return 'blur(2px)';
  }
  else if (prop < 2) {
    return 'blur(4px)';
  }
  else if (prop < 3) {
    return 'blur(7px)';
  }
  else if (prop < 4) {
    return 'blur(12px)';
  }
  else {

  }
}

const getRosaceaBlur = (prop) => {
  if (prop < 1) {
    return 'blur(4px)';
  }
  else if (prop < 1.5) {
    return 'blur(4px)';
  }
  else if (prop < 2) {
    return 'blur(5px)';
  }
  else if (prop < 3) {
    return 'blur(13px)';
  }
  else if (prop < 4) {
    return 'blur(18px)';
  }
  else {
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if (prop < 0.5) {
    return 2;
  }
  else if (prop < 1) {
    return 4;
  }
  else if (prop < 1.5) {
    return 7;
  }
  else if (prop < 2) {
    return 10;
  }
  else if (prop < 3) {
    return 14;
  }
  else if (prop < 4) {
    return 15;
  }
  else {
    console.log("out of bound props - Acne");
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if (prop < 1) {
    return 1;
  }
  else if (prop < 1.5) {
    return 6;
  }
  else if (prop < 2) {
    return 6;
  }
  else if (prop < 3) {
    return 14;
  }
  else if (prop < 4) {
    return 15;
  }
  else {
    console.log("out of bound props - DarkSpots");
  }
}

const getTextureLineWidth = (prop) => {
  if (prop < 0.5) {
    return 2;
  }
  else if (prop < 1) {
    return 3;
  }
  else if (prop < 1.5) {
    return 6;
  }
  else if (prop < 2) {
    return 10;
  }
  else if (prop < 3) {
    return 14;
  }
  else if (prop < 4) {
    return 16;
  }
  else {
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if (prop < 1) {
    return 4;
  }
  else if (prop < 1.5) {
    return 6;
  }
  else if (prop < 2) {
    return 10;
  }
  else if (prop < 3) {
    return 15;
  }
  else if (prop < 4) {
    return 30;
  }
  else {
    console.log("out of bound props - Wrinkle");
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill = false, stroke = false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}